/* ELORIA — Product Page interactions (scoped to .pdp) */
(function () {
  const root = document.querySelector('.pdp');
  if (!root) return;

  const $ = (s, c = root) => c.querySelector(s);
  const $$ = (s, c = root) => Array.from(c.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- data ---------- */
  let variants = [];
  let meta = {};
  try { variants = JSON.parse($('[data-pdp-variant-data]').textContent) || []; } catch (e) {}
  try { meta = JSON.parse($('[data-pdp-product-meta]').textContent) || {}; } catch (e) {}

  const moneyFormat = (meta.money_format || '${{amount}}');
  function formatMoney(cents) {
    if (cents == null) return '';
    const amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const whole = (cents / 100).toLocaleString(undefined, { maximumFractionDigits: 0 });
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount);
  }

  /* ---------- gallery ---------- */
  const stageMedia = $('[data-pdp-media]');
  const stage = $('[data-pdp-stage]');
  function showMedia(thumb) {
    if (!stageMedia) return;
    const type = thumb.dataset.mediaType;
    const full = thumb.dataset.full;
    if (type === 'video' || type === 'external_video') {
      if (thumb.dataset.embed) {
        const src = thumb.dataset.host === 'youtube'
          ? `https://www.youtube.com/embed/${thumb.dataset.embed}?autoplay=1`
          : `https://player.vimeo.com/video/${thumb.dataset.embed}?autoplay=1`;
        stageMedia.innerHTML = `<iframe src="${src}" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
      } else {
        stageMedia.innerHTML = `<video src="${full}" controls autoplay playsinline></video>`;
      }
      stage.classList.remove('is-zoom');
    } else if (full) {
      stageMedia.innerHTML = `<img class="pdp-stage__img" src="${full}" alt="">`;
      stage.classList.add('is-zoom');
    }
    $$('.pdp-thumb').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }
  $$('[data-pdp-thumbs] .pdp-thumb').forEach(t => {
    t.addEventListener('click', () => showMedia(t));
    t.addEventListener('mouseenter', () => { if (t.dataset.mediaType === 'image') showMedia(t); });
  });

  // hover zoom
  if (stage) {
    stage.addEventListener('mousemove', (e) => {
      const img = $('.pdp-stage__img', stage);
      if (!img || !stage.classList.contains('is-zoom')) return;
      const r = stage.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      img.style.transform = 'scale(1.6)';
    });
    stage.addEventListener('mouseleave', () => {
      const img = $('.pdp-stage__img', stage);
      if (img) img.style.transform = '';
    });
  }

  // lightbox
  const lb = $('[data-pdp-lightbox]');
  const lbImg = $('[data-pdp-lightbox-img]');
  function openLightbox() {
    const img = $('.pdp-stage__img', stage);
    if (!img || !lb) return;
    lbImg.src = img.src;
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() { if (lb) { lb.classList.remove('is-open'); document.body.style.overflow = ''; } }
  $('[data-pdp-expand]')?.addEventListener('click', openLightbox);
  $('[data-pdp-lightbox-close]')?.addEventListener('click', closeLightbox);
  lb?.addEventListener('click', (e) => { if (e.target === lb) closeLightbox(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLightbox(); });

  /* ---------- variant selection ---------- */
  const idInput = $('[data-pdp-variant-id]');
  const priceEl = $('[data-pdp-price]');
  const compareEl = $('[data-pdp-compare]');
  const stickyPrice = $('[data-pdp-sticky-price]');
  const addLabel = $('[data-pdp-add-label]');
  const addBtn = $('[data-pdp-add]');

  function selectedOptions() {
    const groups = $$('[data-pdp-optgroup]');
    if (!groups.length) return null;
    const opts = [];
    groups.forEach(g => {
      const idx = parseInt(g.dataset.optionIndex, 10);
      const sel = g.querySelector('[data-pdp-optselect]');
      if (sel) { opts[idx] = sel.value; }
      else { const active = $('.is-active', g); opts[idx] = active ? active.dataset.value : null; }
    });
    return opts;
  }

  function updateVariant() {
    const sel = selectedOptions();
    if (!sel || !variants.length) return;
    const match = variants.find(v => v.options.every((o, i) => o === sel[i]));
    if (!match) return;
    if (idInput) idInput.value = match.id;
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.style.display = '';
      } else { compareEl.style.display = 'none'; }
    }
    if (addLabel) addLabel.textContent = match.available ? 'Add to Bag' : 'Sold Out';
    if (addBtn) addBtn.disabled = !match.available;
    // swap stage image to variant image
    if (match.featured_image && stageMedia && stage.classList.contains('is-zoom')) {
      const img = $('.pdp-stage__img', stage);
      if (img) img.src = match.featured_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_1200x$1');
    }
    // reflect selected value labels
    $$('[data-pdp-optvalue]').forEach(el => {
      const idx = parseInt(el.dataset.pdpOptvalue, 10);
      if (sel[idx]) el.textContent = sel[idx];
    });
  }

  $$('[data-pdp-opt]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-soldout')) return;
      const group = btn.closest('[data-pdp-optgroup]');
      $$('[data-pdp-opt]', group).forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      updateVariant();
    });
  });
  $$('[data-pdp-optselect]').forEach(sel => sel.addEventListener('change', updateVariant));
  // fallback preview pills (no variant data)
  $$('.pdp-pills .pdp-pill:not([data-pdp-opt]), .pdp-swatches .pdp-swatch:not([data-pdp-opt])').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.parentElement.querySelectorAll('.pdp-pill, .pdp-swatch').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  /* ---------- quantity ---------- */
  const qtyInput = $('[data-pdp-qty-input]');
  $$('[data-pdp-qty]').forEach(b => b.addEventListener('click', () => {
    if (!qtyInput) return;
    const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.pdpQty, 10));
    qtyInput.value = next;
  }));

  /* ---------- add to cart ---------- */
  const form = $('#pdp-form');
  function addToCart() {
    if (!form) return Promise.reject();
    const data = new FormData(form);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(r => r.json());
  }
  function afterAdd() {
    if (typeof window.refreshEloriaCartDrawer === 'function') window.refreshEloriaCartDrawer();
    if (typeof window.openEloriaCartDrawer === 'function') window.openEloriaCartDrawer();
    else window.location.href = '/cart';
  }
  form?.addEventListener('submit', (e) => { e.preventDefault(); addToCart().then(afterAdd).catch(() => {}); });
  $('[data-pdp-buy]')?.addEventListener('click', () => { addToCart().then(() => window.location.href = '/checkout').catch(() => {}); });
  $('[data-pdp-sticky-add]')?.addEventListener('click', () => { addToCart().then(afterAdd).catch(() => {}); });

  // quick add (related)
  $$('[data-pdp-quickadd]').forEach(b => b.addEventListener('click', (e) => {
    e.preventDefault();
    const id = b.dataset.pdpQuickadd;
    if (!id) return;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(() => afterAdd()).catch(() => {});
  }));

  /* ---------- wishlist ---------- */
  const wish = $('[data-pdp-wishlist]');
  if (wish && meta.id) {
    const key = 'eloria_wishlist';
    const list = JSON.parse(localStorage.getItem(key) || '[]');
    if (list.includes(meta.id)) wish.classList.add('is-active');
    wish.addEventListener('click', () => {
      let l = JSON.parse(localStorage.getItem(key) || '[]');
      if (l.includes(meta.id)) { l = l.filter(x => x !== meta.id); wish.classList.remove('is-active'); }
      else { l.push(meta.id); wish.classList.add('is-active'); }
      localStorage.setItem(key, JSON.stringify(l));
    });
  }

  /* ---------- accordions ---------- */
  $$('[data-pdp-accordion] .pdp-acc').forEach(acc => {
    const btn = $('.pdp-acc__btn', acc);
    const body = $('.pdp-acc__body', acc);
    function setOpen(open) {
      if (open) {
        body.style.maxHeight = body.scrollHeight + 'px';
        const done = () => { if (acc.classList.contains('is-open')) body.style.maxHeight = 'none'; body.removeEventListener('transitionend', done); };
        body.addEventListener('transitionend', done);
      } else {
        body.style.maxHeight = body.scrollHeight + 'px';
        requestAnimationFrame(() => { body.style.maxHeight = '0px'; });
      }
    }
    if (acc.classList.contains('is-open')) body.style.maxHeight = 'none';
    btn.addEventListener('click', () => setOpen(acc.classList.toggle('is-open')));
  });

  /* ---------- sticky ATC ---------- */
  const sticky = $('[data-pdp-sticky]');
  if (sticky && form) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0));
    }, { threshold: 0 });
    io.observe(form);
  }

  /* ---------- carousels ---------- */
  $$('.pdp-carousel').forEach(car => {
    const track = $('[data-pdp-carousel], [data-pdp-recent]', car);
    const prev = $('[data-pdp-carousel-prev]', car);
    const next = $('[data-pdp-carousel-next]', car);
    if (!track) return;
    const step = () => (track.querySelector('.pdp-pcard')?.getBoundingClientRect().width || 280) + 24;
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- mobile swipe gallery ---------- */
  (function mobileGallery() {
    const track = $('[data-pdp-mtrack]');
    const dotsWrap = $('[data-pdp-mdots]');
    if (!track || !dotsWrap) return;
    const slides = $$('.pdp-mslide', track);
    if (slides.length <= 1) { dotsWrap.style.display = 'none'; return; }
    slides.forEach((s, i) => {
      const b = document.createElement('button');
      b.className = 'pdp-mdot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Go to image ' + (i + 1));
      b.addEventListener('click', () => track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }));
      dotsWrap.appendChild(b);
    });
    const dots = $$('.pdp-mdot', dotsWrap);
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      });
    }, { passive: true });
  })();

  /* ---------- recently viewed ---------- */
  (function recentlyViewed() {
    if (!meta.id) return;
    const key = 'eloria_recent';
    let list = JSON.parse(localStorage.getItem(key) || '[]').filter(p => p.id !== meta.id);
    const section = $('[data-pdp-recent-section]');
    const track = $('[data-pdp-recent]');
    if (track && list.length) {
      track.innerHTML = list.slice(0, 8).map(p => `
        <div class="pdp-pcard">
          <a href="${esc(p.url)}" class="pdp-pcard__img"><img src="${esc(p.image || '')}" alt="${esc(p.title)}" loading="lazy"></a>
          <h3 class="pdp-pcard__name">${esc(p.title)}</h3>
          <div class="pdp-pcard__price">${formatMoney(p.price)}</div>
        </div>`).join('');
      if (section) section.hidden = false;
    }
    // record current
    list.unshift({ id: meta.id, title: meta.title, url: meta.url, image: meta.image, price: meta.price });
    localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
  })();

  /* ---------- jump links ---------- */
  $$('[data-pdp-jump]').forEach(b => b.addEventListener('click', () => {
    const el = document.querySelector(b.dataset.pdpJump);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  /* ---------- reveal on scroll (fail-safe) ---------- */
  root.classList.add('pdp-js');
  const reveals = $$('.pdp-reveal');
  const ro = new IntersectionObserver((entries) => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
  reveals.forEach(el => ro.observe(el));
  // reveal anything already in/above the viewport immediately
  requestAnimationFrame(() => {
    reveals.forEach(el => { if (el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('is-in'); });
  });
  // safety net: never leave a section hidden
  setTimeout(() => reveals.forEach(el => el.classList.add('is-in')), 2400);
})();
